import { confirmDialog, CustomCollapseCard, CustomImage, Text } from '@src/components';
import { Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteUnCompleted,
  getCurrentCardOrder,
  setCurrentCardOrder,
  setCardOrderPopupDigital,
} from '@src/store/slice/cardOrderSlice';
import { cardImagesGetByVouId } from '@src/store/slice/cardImagesSlice';
import React, { useEffect,useState } from 'react';
import '@src/styles/cardOrder/cardType.scss';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import CardDigital from '@src/assets/images/cardOrders/img-dijital-kart.webp';
import CardClassic from '@src/assets/images/cardOrders/edenred-card.webp';
import DigitalCardIncentive from './DigitalCardIncentive';
import { setLoadingState } from '@src/store/slice/appSettingsSlice';


const CardType = ({ form }) => {
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const [digitalModalVisible, setDigitalModalVisible] = useState(false);
  const [isModalClosed, setIsModalClosed] = useState(true);
  const { cardList } = useSelector((state) => state?.cardOrderDetails);
  const dispatch = useDispatch();

  const isMobil = useMediaQuery({ query: '(max-width: 1198.99px)' });

  useEffect(() => {
    if (!isModalClosed) {
      updateCardType(1);
    }
  }, [isModalClosed]);

  useEffect(() => {
    if (currentCardOrder?.vouId) {
      dispatch(cardImagesGetByVouId(currentCardOrder?.vouId));
    }
  }, [currentCardOrder]);

  const changeType = async (e) => {
    try {
      dispatch(setLoadingState(true));

      await dispatch(deleteUnCompleted());
      await dispatch(getCurrentCardOrder());
      await dispatch(setCurrentCardOrder({ cardType: e?.target?.value }));

      if (e?.target?.value === 0) {
        setDigitalModalVisible(true);
      }else {
        setCardOrderPopupDigital(false);
      }
    } catch (e) { console.error('error', e); }
    finally {
      dispatch(setLoadingState(false));
    }
  };

  const updateCardType = async (type) => {
    await dispatch(deleteUnCompleted());
    await dispatch(getCurrentCardOrder());
    dispatch(setCurrentCardOrder({ cardType: type }));
    setIsModalClosed(true);
  };


  const onChange = (e) => {
    const fieldsValue = form.getFieldsValue();
    const isFill = Object.values(form.getFieldsValue()).every((item) => !item);
    if (cardList.length === 0) return;
    if (
      (cardList[0].name && currentCardOrder?.cardType === 1) ||
      (!isFill &&
        currentCardOrder?.cardType === 1 &&
        (fieldsValue.name ||
          fieldsValue.surname ||
          fieldsValue.gsm ||
          fieldsValue.price ||
          fieldsValue.refNo))
    ) {
      confirmDialog({
        title: <Text t="attention" />,
        htmlContent: (
          <Text t="withThisOptionYouHaveSelectedYouAre" />
        ),
        onOk: () => {
          changeType(e);
        },
      });
    } else {
      changeType(e);
    }
  };

  const value = currentCardOrder?.cardType;

  return (
    <>
    <CustomCollapseCard
      bodyCenter
      cardTitle={<Text t="cardTypeTitle" />}
      cardTitleAlign="center"
      className="card-order-collapse "
    >
      <Radio.Group id="ticketRestaurant-cardOrders-cardInformation-cardType-custom-radioGroup-input-content" onChange={onChange} value={value} className="custom-radio-input-content">
        <Radio
          id="ticketRestaurant-cardOrders-cardInformation-cardType-custom-radio-input-content1"
          value={1}
          style={{
            border: value === 1 ? '2px solid #1da483' : '2px solid #fff',
            borderRadius: '8px',
          }}
        >
          {!isMobil ? (
            <div className="credit-card-item">
              <div className="credit-card-item-first-area">
                <h4>
                  <Text t="digitalCard" />
                </h4>
                <CustomImage className="bank-card-logo" src={CardDigital} />
              </div>
              <div className="card-info">
                <p>
                  <Text t="digitalCardDescription" />
                </p>
              </div>
            </div>
          ) : (
            <div className="credit-card-item">
              <div className="credit-card-item-first-area">
                <CustomImage className="bank-card-logo" src={CardDigital} />
              </div>
              <div className="card-info">
                <h4>
                  <Text t="digitalCard" />
                </h4>
                <p>
                  <Text t="digitalCardDescription" />
                </p>
              </div>
            </div>
          )}
        </Radio>

        <Radio
          id="ticketRestaurant-cardOrders-cardInformation-cardType-custom-radio-input-content0"
          value={0}
          style={{
            border: value === 0 ? '2px solid #1da483' : '2px solid #fff',
            borderRadius: '8px',
          }}
        >
          {!isMobil ? (
            <div className="credit-card-item">
              <div className="credit-card-item-first-area">
                <h4>
                  <Text t="classicCard" />
                </h4>
                <CustomImage className="bank-card-logo" src={CardClassic} />
              </div>
              <div className="card-info">
                <p>
                  <Text t="classicCardDescription" />
                </p>
              </div>
            </div>
          ) : (
            <div className="credit-card-item">
              <div className="credit-card-item-first-area">
                <CustomImage className="bank-card-logo" src={CardClassic} />
              </div>
              <div className="card-info">
                <h4>
                  <Text t="classicCard" />
                </h4>
                <p>
                  <Text t="classicCardDescription" />
                </p>
              </div>
            </div>
          )}
        </Radio>
      </Radio.Group>
    </CustomCollapseCard>
    <DigitalCardIncentive digitalModalVisible={digitalModalVisible} setDigitalModalVisible={setDigitalModalVisible} isModalClosed={isModalClosed} setIsModalClosed={setIsModalClosed}/>
    </>
  );
};

export default CardType;
